import React, { Component } from 'react';
import PropTypes from 'prop-types';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import Tooltip from '@material-ui/core/Tooltip';
import { connect } from 'react-redux';
import { ROLE_ADMIN, ROLE_USER } from '../../constants/roles';

export class BikeTableHead extends Component {
  state = {
    role: ROLE_USER,
  };

  static getDerivedStateFromProps(props) {
    let newState = null;
    if (props.authUser && props.roles) {
      const role = props.roles[props.authUser.uid];
      newState = { ...newState, role };
    }
    return newState;
  }

  createSortHandler = property => (event) => {
    this.props.onRequestSort(event, property);
  };

  render() {
    const { order, orderBy } = this.props;

    const columnData = [
      {
        id: 'number', label: 'N°',
      },
      {
        id: 'padlock_number', label: 'Cadenas',
      },
      {
        id: 'renterName', label: 'Loueur',
      },
      {
        id: 'siteName', label: 'Site',
      },
      {
        id: 'bikeState', label: 'Etat',
      },
      {
        id: 'mac_address', label: 'Adresse MAC',
      },
      {
        id: 'rfid', label: 'RFID',
      },
      {
        id: 'type', label: 'Public',
      },
      {
        id: 'is_electric', label: 'Type',
      }
    ];

    if (!this.props.isInBikePage || this.state.role < ROLE_ADMIN) {
      columnData.splice(columnData.findIndex(column => column.id === 'renterName'), 1);
    }
    return (
      <TableHead>
        <TableRow>
          {columnData.map(column => (
            <TableCell
              key={column.id}
              padding={column.disablePadding ? 'none' : 'normal'}
              sortDirection={orderBy === column.id ? order : false}>
              <Tooltip
                title="Trier"
                placement={column.numeric ? 'bottom-end' : 'bottom-start'}
                enterDelay={300}>
                <TableSortLabel
                  active={orderBy === column.id}
                  direction={order === 'asc' ? 'desc' : 'asc'}
                  onClick={this.createSortHandler(column.id)}>
                  {column.label}
                </TableSortLabel>
              </Tooltip>
            </TableCell>
          ), this)}
          <TableCell padding="checkbox">
          </TableCell>
        </TableRow>
      </TableHead>
    );
  }
}

BikeTableHead.propTypes = {
  onRequestSort: PropTypes.func.isRequired,
  order: PropTypes.string.isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
  isInBikePage: PropTypes.bool.isRequired
};

function mapStateToProps(state) {
  return {
    authUser: state.users.authUser,
    roles: state.roles.content,
  };
}

export default connect(mapStateToProps)(BikeTableHead);



// WEBPACK FOOTER //
// ./src/components/Bike/BikeTableHead.jsx